/* eslint-disable ember/no-computed-properties-in-native-classes */
import Controller from '@ember/controller';
import { computed, set } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { OTHER_OPTION_ID } from 'lumen/utils/constants/otb-selfservice-constants';

export default class HotelSettingsMyotbMyotbBaseController extends Controller {
  @service myotbSs;

  @tracked isLoading = false;

  @computed('myotbSs.otbSelfService')
  get otbSelfService() {
    return this.myotbSs?.otbSelfService;
  }

  set otbSelfService(value) {
    set(this, 'myotbSs.otbSelfService', value);
  }

  pmsAndOtherSystemSearchMatcher(pmsOrOtherSystem, searchTerm) {
    // Always match the 'Other' PMS row
    if (pmsOrOtherSystem.id === OTHER_OPTION_ID) {
      return true;
    }

    return pmsOrOtherSystem.label
      .toLowerCase()
      .indexOf(searchTerm.toLowerCase());
  }
}
